//活动成员
<template>
    <div class="circle-member">
        <el-dialog :title="`${$t('con.activity_member')}(${list.length})`" :visible.sync="show" width="50%"
            :before-close="handleClose">
            <ul>
                <li v-for="(item, index) in list" :key="index" class="flex-row-center-between"
                    @click="handleSkip(`/personal?id=${item.id}`)">
                    <div class="user-info flex-row-center">
                        <img :src="item.avatar" />
                        <div class="sec">
                            <div class="name">{{ item.name }}</div>
                            <div class="bio x-ell-1">{{ item.introduction || $t('auth.nulldesc') }}</div>
                        </div>
                        <div class="time">{{ item.time }}</div>
                    </div>

                </li>
            </ul>
            <pagination :page-sizes="getPageSize()" v-show="total > 0" :total="total" align="center" :page.sync="page"
                :limit.sync="paginate" @pagination="handlePage" />
            <span slot="footer" class="dialog-footer"></span>
        </el-dialog>
    </div>
</template>
<script>
import pagination from '@/components/pagination.vue'
export default {
    components: { pagination },
    props: ["show", 'id'],
    data() {
        return {

            list: [],
            total: 0,
            page: 1,
            paginate: 20

        };
    },
    created() {
        this.getList()
    },
    methods: {
        handlePage(val){
            this.getList(val.page)
        },
        //获取圈子成员
        getList() {
            this.$api.get(`/api/activity-user/${this.id}`, { params: { page: this.page } }).then(res => {
                this.list = res.data.data
                this.total = res.data.meta.total
            })
        },
        //关闭
        handleClose() {
            this.$emit('handleClose')
        },
        //关注 取消关注
        handleFollow(state, id, index) {
            if (state == 0) {
                this.$api.post(`/api/follow/user/${id}`).then(() => {
                    this.list[index].has_follow = 1
                    this.$message.success(this.$t('circle.focus_success'))
                })
            } else {
                this.$api.delete(`/api/follow/user/${id}`).then(() => {
                    this.list[index].has_follow = 0
                    this.$message.success(this.$t('circle.cancel_success'))
                })
            }
        },
        handleSkip(url) {
            this.$router.push(url)
        },
        getPageSize() {

        }
    }

};
</script>
<style scoped lang="scss">
.circle-member {
    ul {
        li {

            margin-bottom: 0.3rem;

            img {
                width: 0.55rem;
                height: 0.55rem;
                border-radius: 50%;
                background-color: #efefef;
            }

            .sec {
                margin-left: 0.06rem;
                flex:1;
                .name {
                    font-size: 0.18rem;
                    color: #202020;
                    line-height: 0.29rem;
                }

                .bio {
                    font-size: 0.15rem;
                    color: #909090;

                }
            }

            .time {
                font-size: 0.16rem;
                color: #909090;
                line-height: 0.24rem;
                margin-left: 0.13rem;
            }

            .btn-wrap {
                .btn {
                    width: 0.69rem;
                    height: 0.32rem;
                    border-radius: 0.03rem;
                    border: 0.01rem solid #02428C;
                    text-align: center;
                    line-height: 0.32rem;
                    cursor: pointer;
                    font-size: 0.16rem;
                    color: #02428C;
                    margin-left: 0.3rem;
                }

                .diff {
                    border: 0.01rem solid #9A9A9A;
                    color: #9A9A9A;
                }
            }
        }
    }
}
</style>
  